import { GrowthBook, GrowthBookProvider as OGGrowthBookProvider } from '@growthbook/growthbook-react';
import React, { useEffect } from 'react';
import clientConfig from '@jucy-nakuru/config/clientConfig';

export const growthbook = clientConfig.app.growthBookKey
    ? new GrowthBook({
          apiHost: 'https://api.insights.jucy.cloud',
          clientKey: clientConfig.app.growthBookKey,
          enableDevMode: true,
          enabled: true,
      })
    : undefined;
export const GrowthBookProvider = ({ children }: { children: React.ReactElement }) => {
    useEffect(() => {
        if (growthbook) {
            growthbook.loadFeatures();
        }
    }, []);
    if (growthbook) {
        return <OGGrowthBookProvider growthbook={growthbook}>{children}</OGGrowthBookProvider>;
    }
    return children;
};
